module.exports = __webpack_public_path__ + "img/caminhao-roxo.51f7e811.png";